import L from 'leaflet';

L.control.playback = function (options, widget) {
	return new L.Control.Playback(options, widget);
};

L.Control.Playback = L.Control.extend({
	options: {
		position: 'bottomright',
	},

	initialize: function (options, widget) {
		L.Util.setOptions(this, options);

		this.widget = widget;
	},

	onAdd: function (map) {
		let container = L.DomUtil.create('div', 'widget-control-playback');
		L.DomEvent.disableClickPropagation(container);

		this._toggle = L.DomUtil.create('button', 'playback-toggle', container);
		L.DomEvent.on(this._toggle, 'click', this._onClick, this);

		this.widget.time.on('TIME_PLAYBACK_STARTED_RESUMED TIME_PLAYBACK_PAUSED', this._update, this);

		return container;
	},

	onRemove: function (map) {
		L.DomEvent.off(this._toggle, 'click', this._onClick, this);

		this.widget.time.off('TIME_PLAYBACK_STARTED_RESUMED TIME_PLAYBACK_PAUSED', this._update, this);
	},

	_onClick: function (event) {
		if (this.widget.time._isPlaying) {
			this.widget.time.pause();
		} else {
			this.widget.time.play();
		}
	},

	_update: function () {
		if (this.widget.time._isPlaying) {
			L.DomUtil.addClass(this._container, 'playback--playing');
		} else {
			L.DomUtil.removeClass(this._container, 'playback--playing');
		}
	},
});
